// Shared diagram-js event/renderer priority. Lives in its own leaf module —
// helpers.ts imports the custom-modules (which need this constant), so
// defining it there creates an import cycle where the renderers read it at
// module scope before helpers.ts finishes evaluating (TDZ ReferenceError;
// which module wins depends on bundle/chunk evaluation order).
// Should be higher than default priority.
export const HIGH_PRIORITY = 1500;
